import { Box, FormGroup, FormParagraph, Select, Text } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { HolterExaminationRequestBase } from '@common/validation/customControls/cardiology/holter/utils/utils';
import { OpnameDuur, opnameDuurOptions } from '@common/enums/opnameDuur';
import { TypeOnderzoek } from '@common/enums/typeOnderzoek';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { getValidationErrorTranslation, useProcessActivityEditContext } from '@frontend/utils';

export function RecordingTimeSelect() {
    const {
        data: { opnameduur, type_onderzoek },
        errors,
    } = useProcessActivityEditContext<HolterExaminationRequestBase>();
    const {
        field: { key, label },
        isRequired,
        onChange,
    } = useEditFormSectionInputFieldContext<HolterExaminationRequestBase>();

    useEffect(() => {
        if (type_onderzoek === TypeOnderzoek.event) {
            onChange(OpnameDuur.zevenDagen);
        } else {
            if (opnameduur === OpnameDuur.zevenDagen) {
                onChange(null);
            }
        }
    }, [type_onderzoek]);

    return (
        <FormGroup
            isRequired={isRequired}
            label={label}
        >
            {type_onderzoek === TypeOnderzoek.event ? (
                <FormParagraph>7 dagen</FormParagraph>
            ) : (
                <Box
                    display="flex"
                    marginBottom={2}
                >
                    <Box width="fit-content">
                        <Select
                            error={getValidationErrorTranslation(errors.get(key))}
                            isDisabled={!type_onderzoek}
                            onChange={(item) => item && onChange(item.value)}
                            options={opnameDuurOptions.map((value) => ({
                                label: value,
                                value,
                            }))}
                            placeholder=""
                            value={opnameduur ? { label: opnameduur, value: opnameduur } : null}
                        />
                    </Box>

                    <Text
                        size="sm"
                        sx={{ alignSelf: 'center', marginLeft: 4 }}
                        textAlign="center"
                    >
                        dagen
                    </Text>
                </Box>
            )}
        </FormGroup>
    );
}
